/**
 * Page-Blog template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from "./lib/global";
import Logger from "./lib/logger";

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = "Page-Muse-Blog";

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

// Bootstrap global functionality
Global();

/**
 * Init
 **/
const init = () => {
	Logger.info(`${NAME} > init...`);
	Collapseable();
};

const Collapseable = () => {
	Logger.info(`${NAME} > initFaqModule...`);

	const dropdownBtn = document.getElementById("blog-container-filters__toggle");
	const dropdownMenu = document.getElementById(
		"blog-container-filters-dropdown"
	);
	const toggleArrow = document.getElementById(
		"blog-container-filters__toggle-svg"
	);

	// Toggle dropdown function
	const toggleDropdown = function () {
		dropdownMenu.classList.toggle("show");
		toggleArrow.classList.toggle("arrow");
	};

	// Toggle dropdown open/close when dropdown button is clicked
	dropdownBtn.addEventListener("click", function (e) {
		e.stopPropagation();
		toggleDropdown();
	});

	// Close dropdown when dom element is clicked
	document.documentElement.addEventListener("click", function () {
		if (dropdownMenu.classList.contains("show")) {
			toggleDropdown();
		}
	});
};

init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
